(function($) {
  
$("#tabs-menu li a").click(function() {
  $("#tabs-menu li").removeClass('selected');
    $(this).parent().addClass('selected');
});

//$("#tabs-menu li:first").addClass('selected');



function frontTabs(){
  
  var leftNav = $('#tabs-menu');
  console.log(leftNav);
}


//function displaySingleProxy(){
//    
//    $(".single-proxy:first").addClass('visible-proxy');
//    var distList = $('#districts a');
//    
//    distList.on('click', function(){
//      
//      $(".single-proxy").hide();
////      distList.removeClass('active-proxy-list');
////      $(this).addClass('active-proxy-list');
//      
//      var activeTab = $(this).attr("href"); 
//      $(activeTab).fadeIn();    
//    });
//
//  };
//  
//  displaySingleProxy();


var tabMenu1 = $('#tab_menu_1');
var tabMenu2 = $('#tab_menu_2');
var tabMenu3 = $('#tab_menu_3');
var tabMenu4 = $('#tab_menu_4');
var tabMenu5 = $('#tab_menu_5');

tabMenu1.on('click', function(){
  $('.main-tab-right').fadeOut(0);
  $('#section-1').fadeIn(1000);
  $('#text-1').fadeIn(1000);
});
  
tabMenu2.on('click', function(){
  $('.main-tab-right').fadeOut(0);
  $('#section-2').fadeIn(1000);
  $('#text-2').fadeIn(1000);
});  
  
tabMenu3.on('click', function(){
  $('.main-tab-right').fadeOut(0);
  $('#section-3').fadeIn(1000);
  $('#text-3').fadeIn(1000);
});  
  
tabMenu4.on('click', function(){
  $('.main-tab-right').fadeOut(0);
  $('#section-4').fadeIn(1000);
  $('#text-4').fadeIn(1000);
});  
  
tabMenu5.on('click', function(){
  $('.main-tab-right').fadeOut(0);
  $('#section-5').fadeIn(1000);
  $('#text-5').fadeIn(1000);
});


})(jQuery);